import { FC, useEffect } from 'react';

interface YouTubePlayerProps {
  videoUrl: string;
  onVideoComplete: () => void;
  onProgressUpdate: (progress: number) => void;
}

export const YouTubePlayer: FC<YouTubePlayerProps> = ({ 
  videoUrl, 
  onVideoComplete,
  onProgressUpdate 
}) => {
  // Extract video ID from URL
  const getYouTubeVideoId = (url: string) => {
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);
    return (match && match[2].length === 11) ? match[2] : null;
  };

  const videoId = getYouTubeVideoId(videoUrl);

  // Configuramos los parámetros para máxima restricción del reproductor de YouTube
  const embedUrl = videoId ? `https://www.youtube.com/embed/${videoId}?` + new URLSearchParams({
    enablejsapi: '1',
    modestbranding: '1',
    controls: '1',
    disablekb: '1',
    rel: '0',
    showinfo: '0',
    fs: '0',
    playsinline: '1',
    origin: window.location.origin,
    iv_load_policy: '3',
    cc_load_policy: '0',
    autohide: '1',
    color: 'white',
    widget_referrer: window.location.origin,
    loop: '0',
    playlist: videoId
  }).toString() : '';

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.data && typeof event.data === 'string') {
        try {
          const data = JSON.parse(event.data);
          if (data.event === 'onStateChange') {
            // State 0 means video ended
            if (data.info === 0) {
              onVideoComplete();
            }
            // Update progress (you might want to implement this based on your needs)
            if (data.info === 1) { // 1 means playing
              // This is a simple example, you might want to implement actual progress tracking
              onProgressUpdate(50); // Example progress update
            }
          }
        } catch (e) {
          // Ignorar errores de parsing
          console.error('Error parsing YouTube player message:', e);
        }
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [onVideoComplete, onProgressUpdate]);

  if (!videoId) {
    console.error('Invalid YouTube URL:', videoUrl);
    return <div>Invalid YouTube URL</div>;
  }

  return (
    <div className="aspect-video rounded-xl overflow-hidden shadow-lg">
      <iframe
        src={embedUrl}
        className="w-full h-full"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope"
        allowFullScreen={false}
        frameBorder="0"
      />
    </div>
  );
};